// export const BASE_URL = 'https://test-tf-api.tap-vibes.com/api/v1';
// export const BASE_URL = 'https://comic.tap-vibes.com/api/v1'; // 'https://test-tf-api.tap-vibes.com/api/v1';
export const TIME_OUT = 10000;
export const MAX_RETRIES = 0;
